var map;
var geocoder;
var markers;
var uAjax = "/index.cfm/shop/ajax/geolocateshops";

$(function()
{
	if(typeof apiKey !== "undefined"){
		var url = 'https://maps.googleapis.com/maps/api/js?key='+apiKey+'&callback=initializeMap';
		$.getScript(url);
	}
	else{
		// Init Google Maps
		if(typeof google !== 'undefined')
		{
			google.maps.event.addDomListener(window, 'load', initializeMap);
		}
	}

	$('#btnSearch').on('click',function()
	{
		var sLocation          = $('.edtLocation').val();
		var sLookupCountry = sCountryCode;
		var sLookupCountryCode = sCountryCode;
		if(typeof $('.inputSearchCountry').val() !== "undefined")
		{
			sLookupCountry = $('.inputSearchCountry').find('option:selected').html();
			sLookupCountryCode =  $('.inputSearchCountry').val();
		}

		if(sLocation != '')
		{
			geoLookup(sLocation,sLookupCountry,handleGeolocateshops,sLookupCountryCode);
		}
	});

	$(".shopList > .row").mouseenter(function(e){
		$(this).addClass('hover');
	});

	$(".shopList > .row").mouseleave(function(e){
		$(this).removeClass('hover');
	});

	$(".edtLocation").keyup(function (e)
	{
	    if (e.keyCode == 13)
		{
			var sLocation          = $('.edtLocation').val();
			var sLookupCountry = sCountryCode;
			var sLookupCountryCode = sCountryCode;
			if(typeof $('.inputSearchCountry').val() !== "undefined")
			{
				sLookupCountry = $('.inputSearchCountry').find('option:selected').html();
				sLookupCountryCode =  $('.inputSearchCountry').val();
			}

			if(sLocation != '')
			{
				geoLookup(sLocation,sLookupCountry,handleGeolocateshops,sLookupCountryCode);
			}
		}
	});

	$(el('searchShop')).on('click','.searchShop .doSearch',function(){
		var sLocation          = $(this).prev().val();
		var sLookupCountry     = sCountryCode;
		var sLookupCountryCode = sCountryCode;

		if(typeof $('.inputSearchCountry').val() !== "undefined")
		{
			sLookupCountry = $('.inputSearchCountry').find('option:selected').html();
			sLookupCountryCode = $('.inputSearchCountry').find('option:selected').val();
		}
		if(sLocation !== '')
		{
			geoLookup(sLocation,sLookupCountry,searchShop,sLookupCountryCode);
		}
	});
	$(el('searchShop')).on('keyup','.searchShop .search',function(e){
		if(e.which === 13)
		{
			var sLocation          = $(this).val();
			var sLookupCountry     = sCountryCode;
			var sLookupCountryCode = sCountryCode;

			if(typeof $('.inputSearchCountry').val() !== "undefined")
			{
				sLookupCountry = $('.inputSearchCountry').find('option:selected').html();
				sLookupCountryCode = $('.inputSearchCountry').find('option:selected').val();
			}
			if(sLocation !== '')
			{
				geoLookup(sLocation,sLookupCountry,searchShop,sLookupCountryCode);
			}
		}
	});

	$(el('mainContainer')).on('change','.inputSearchCountry',function(e){
		fnCountryChanged(e);
	});

	if (typeof bLocationPromptShopList !== 'undefined' && bLocationPromptShopList == 1)
	{
		var bTouchDevice = isTouchDevice();
		if(bTouchDevice)
		{
			getLocation();
		}
	}
});

var fnCountryChanged = function(oEvent){

	if($(oEvent.currentTarget).val() != ""){
		var sCountry = $(oEvent.currentTarget).find('option:selected').html();
		geocoder.geocode( {'address' : sCountry}, function(results, status) {
		    if (status == google.maps.GeocoderStatus.OK) {
		        map.panTo(results[0].geometry.location);
				map.fitBounds(results[0].geometry.viewport);
				map.panToBounds(results[0].geometry.viewport);
				// zoom 1 lvl deeper, GMaps is too conservative
				map.setZoom(map.getZoom()+1);
		    }
		});
		$('.locationInputBox').show();
	}
	else{
		$('.locationInputBox').hide();
	}
}

function getLocation() {
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition(showPosition);
	}
}

function handleGeolocateshops(oLookup)
{
	if(typeof toList != 'undefined' && toList == 1)
	{
		var sParams = '?latitude=' + oLookup.results[0].geometry.location.lat()
		+ '&longitude=' + oLookup.results[0].geometry.location.lng()
		+ '&location=' + oLookup.location
		+ '&countryCode=' + oLookup.countryCode;
		window.location = '/' + sCurrentLanguageCode + '/shop/list/' + sParams;
	}
	else
	{
		$(document).trigger( "findLocation");
		map.panTo(oLookup.results[0].geometry.location);
		map.fitBounds(oLookup.results[0].geometry.viewport);

		var sParams = '&latitude=' + oLookup.results[0].geometry.location.lat()
		+ '&longitude=' + oLookup.results[0].geometry.location.lng() + "&countryCode=" + oLookup.countryCode;


		var oCall = callAjax("geolocateshops", sParams, "post");

		// process feedback
		oCall.success(function(oData)
		{
			if(oData.errorType == '')
			{
				$('.shopOverview').html(oData.html);
			}
			else
			{
				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}

			// Hide loader
			$('.ajaxLoader').fadeOut(200);
		});
	}
}
function initializeMap() {

	map = new google.maps.Map(document.getElementById('googleMap'),
		mapOptions);
	geocoder = new google.maps.Geocoder();
	markers = googleMapMarkers();
	$('.inputSearchCountry').trigger('change');
}

function showPosition(position) {
	var sParams = '&latitude=' + position.coords.latitude
	+ '&longitude=' + position.coords.longitude;

	var oCall = callAjax("geolocateshops", sParams, "post");

	// process feedback
	oCall.success(function(oData)
	{
		if(oData.errorType == '')
		{
			$('.shopOverview').html(oData.html);
		}
		else
		{
			// show error message
			showAlert('error', oData.errorMessage, oData.errorUnhandled);
		}

		// Hide loader
		$('.ajaxLoader').fadeOut(200);
	});
}

if(typeof callbackClosestShop === "undefined"){
	var callbackClosestShop = function(sShopId,sLocation)
	{
		var sParams = '&id=' + sShopId;
		var oCall = callAjax("detail", sParams, "post", "/index.cfm/shop/ajax/detail");

		// process feedback
		oCall.success(function(oData)
		{
			if(oData.errorType == '')
			{
				if(!geocoder)
				{
					geocoder = new google.maps.Geocoder();
				}
				geocoder.geocode( { 'address': sLocation+",be"}, function(results, status)
				{
					map.setZoom(12);
					map.setCenter(results[0].geometry.location);
				});

				$('.shopDetail').html(oData.html);
			}
			else if(oData.errorType === 'loggedOut')
			{
				location.reload();
			}
			else
			{
				// show error message
				showAlert('error', oData.errorMessage, oData.errorUnhandled);
			}
		});
	}
}